import { render } from "./CnpjInput.vue?vue&type=template&id=94c9da12&ts=true"
import script from "./CnpjInput.vue?vue&type=script&lang=ts"
export * from "./CnpjInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__